import {
  // FaFacebookF,
  FaInstagram,
  // FaLinkedinIn,
  // FaYoutube,
  FaWhatsapp,
  FaHome,
  FaUser,
  FaTools,
  FaBriefcase,
  FaEnvelope,
  FaTiktok
} from "react-icons/fa";

import "./Footer.css";

function Footer() {
  return (
    <footer className="footer">
      <div className="footer-container">

        {/* ABOUT */}
        <div className="footer-about">
         <div className="footer-logo">
  <img src="/logo2.png" alt="Mahad Nadeem Logo" />
</div>

          <p>
            Creative Portfolio showcasing professional work,
            skills, experience and passion for creating
            outstanding digital experiences.
          </p>
        </div>

        {/* QUICK LINKS */}
        <div className="footer-links">
          <h4>Quick Links</h4>

          <a href="/"><FaHome /> Home</a>
          <a href="/about"><FaUser /> About</a>
          <a href="/skills"><FaTools /> Skills</a>
          <a href="/projects"><FaBriefcase /> Projects</a>
          <a href="/contact"><FaEnvelope /> Contact</a>
        </div>

        {/* CONTACT */}
        <div className="footer-contact">
          <h4>Contact</h4>

          <p>📧 mahadnadeem2468@gmail.com</p>
          <p>📱 +92 03706799599</p>
          <p>📍 Sahiwal, Pakistan</p>
        </div>

        {/* SOCIAL */}
        <div className="footer-social">
          <h4>Follow Me</h4>

          <div className="social-icons">

            {/* <a href="https://facebook.com" target="_blank" rel="noreferrer">
              <FaFacebookF />
            </a> */}

            <a href="https://www.instagram.com/_mahad_nadeem?igsh=MTgwbHd6enlrMTI2Zg==" target="_blank" rel="noreferrer">
              <FaInstagram />
            </a>
            <a href="https://www.tiktok.com/@appleuser33966770?_r=1&_t=ZS-97QbzfpznHt" target="_blank" rel="noreferrer">
              <FaTiktok />
            </a>
            {/* <a href="https://linkedin.com" target="_blank" rel="noreferrer">
              <FaLinkedinIn />
            </a>

            <a href="https://youtube.com" target="_blank" rel="noreferrer">
              <FaYoutube />
            </a> */}

            <a href="https://wa.me/923001234567" target="_blank" rel="noreferrer">
              <FaWhatsapp />
            </a>

          </div>
        </div>

      </div>

      <div className="footer-bottom">
        © 2026 Mahad Nadeem. All Rights Reserved.
      </div>
    </footer>
  );
}

export default Footer;